<div class="wl-body template-website">
  <div class="container">
    <div class="template_wl">

      <!-- Browser-style top bar -->
      <header class="wl-chrome">
        <div class="wl-dots"><i></i><i></i><i></i></div>
        <div class="wl-url">
          <i class="fa-solid fa-lock"></i>
          <span *ngIf="buttons && buttons.length > 0 && buttons[0].LinkButtonLink">{{ hostOf(buttons[0].LinkButtonLink) }}</span>
          <span *ngIf="!(buttons && buttons.length > 0 && buttons[0].LinkButtonLink)">{{ firstName | lowercase }}{{ lastName | lowercase }}.card</span>
        </div>
        <!-- Dynamic template name badge -->
        <div class="wl-type-badge">{{ templateName }}</div>
      </header>

      <!-- Profile row -->
      <section class="wl-profile">
        <div class="wl-avatar"><img [src]="imageSrc" alt="profileImage" /></div>
        <div class="wl-who">
          <h1>{{ firstName + ' ' + lastName }}</h1>
          <p>{{ jobTitle }}<span *ngIf="companyName"> · {{ companyName }}</span></p>
        </div>
      </section>
      <div class="wl-about" *ngIf="content" [innerHTML]="content"></div>

      <!-- Featured website (pehla link) -->
      <section class="wl-feature" *ngIf="buttons && buttons.length > 0 && buttons[0].LinkButtonTitle">
        <a class="wl-hero" [href]="buttons[0].LinkButtonLink" target="_blank" [style.background]="buttonColor || null">
          <span class="wl-tag"><i class="fa-solid fa-star"></i> Featured</span>
          <b>{{ buttons[0].LinkButtonTitle }}</b>
          <small>{{ hostOf(buttons[0].LinkButtonLink) }}</small>
          <span class="wl-visit">Visit site <i class="fa-solid fa-arrow-right"></i></span>
        </a>
      </section>

      <!-- Baqi website links -->
      <section class="wl-list" *ngIf="buttons && buttons.length > 1 && buttons[0].LinkButtonTitle">
        <div class="wl-h">More links</div>
        <ng-container *ngFor="let button of buttons.slice(1)">
          <a class="wl-site" *ngIf="button" [href]="button.LinkButtonLink" target="_blank">
            <span class="wl-fav" [style.background-color]="buttonColor || null">{{ (button.LinkButtonTitle || '?').charAt(0) }}</span>
            <span class="wl-site-txt">
              <b>{{ button.LinkButtonTitle }}</b>
              <small>{{ hostOf(button.LinkButtonLink) }}</small>
            </span>
            <i class="fa-solid fa-arrow-up-right-from-square"></i>
          </a>
        </ng-container>
      </section>

      <!-- Social chips -->
      <section class="wl-social" *ngIf="instagram || youtube || facebook || twitter || linkedin || pinterest">
        <a [href]="instagram" target="_blank" *ngIf="instagram" class="wl-s-instagram"><i class="fa-brands fa-instagram"></i></a>
        <a [href]="youtube" target="_blank" *ngIf="youtube" class="wl-s-youtube"><i class="fa-brands fa-youtube"></i></a>
        <a [href]="facebook" target="_blank" *ngIf="facebook" class="wl-s-facebook"><i class="fa-brands fa-facebook-f"></i></a>
        <a [href]="twitter" target="_blank" *ngIf="twitter" class="wl-s-twitter"><i class="fa-brands fa-twitter"></i></a>
        <a [href]="linkedin" target="_blank" *ngIf="linkedin" class="wl-s-linkedin"><i class="fa-brands fa-linkedin-in"></i></a>
        <a [href]="pinterest" target="_blank" *ngIf="pinterest" class="wl-s-pinterest"><i class="fa-brands fa-pinterest-p"></i></a>
      </section>

      <section class="wl-contact">
        <a [href]="'tel:' + phone" class="wl-c-tel"><i class="fa-solid fa-phone"></i></a>
        <a [href]="'sms:' + phone" *ngIf="phoneAllow" class="wl-c-sms"><i class="fa-solid fa-comments"></i></a>
        <a [href]="'mailto:' + email" class="wl-c-mail"><i class="fa-solid fa-envelope"></i></a>
        <a [href]="'https://www.google.com/maps?q=' + address" target="_blank" class="wl-c-map" *ngIf="address"><i class="fa-solid fa-location-dot"></i></a>
      </section>

      <div class="wl-facts" *ngIf="gpa || school || grade || height || age || weight">
        <span *ngIf="gpa"><b>GPA</b> {{ gpa }}</span>
        <span *ngIf="school"><b>School</b> {{ school }}</span>
        <span *ngIf="grade"><b>Grade</b> {{ grade }}</span>
        <span *ngIf="height"><b>Height</b> {{ height }}</span>
        <span *ngIf="age"><b>Age</b> {{ age }}</span>
        <span *ngIf="weight"><b>Weight</b> {{ weight }}</span>
      </div>

      <section class="wl-gallery" *ngIf="productImages">
        <img *ngFor="let img of productImages; trackBy: trackByIndex" [src]="img" alt="productImage" />
      </section>

      <!-- VIDEOS: YouTube + Umyotube (YouTube / Dailymotion / umyovideo) + Vimeo -->
      <section class="wl-videos">
        <div class="wl-sec-title" *ngIf="(youtubeArray && youtubeArray.length > 0 && youtubeArray[0].youtubeLink) || (vimeoArray && vimeoArray.length > 0 && vimeoArray[0].vimeoVideoLink) || (umyotubeArray && umyotubeArray.length > 0 && umyotubeArray[0].umyotubeLink)">
          <i class="fa-solid fa-circle-play"></i> Latest videos
        </div>

        <ng-container *ngFor="let v of youtubeArray">
          <div class="wl-video" *ngIf="v.youtubeLink | videoEmbed as src">
            <p class="wl-video-title"><i class="fa-brands fa-youtube"></i> {{ v.youtubeTitle }}</p>
            <div class="wl-embed">
              <iframe [src]="src" [title]="v.youtubeTitle || 'YouTube player'" frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
          </div>
        </ng-container>

        <ng-container *ngFor="let v of umyotubeArray">
          <div class="wl-video" *ngIf="v.umyotubeLink | videoEmbed as src">
            <p class="wl-video-title"><i class="fa-solid fa-circle-play"></i> {{ v.umyotubeTitle }}</p>
            <div class="wl-embed">
              <iframe [src]="src" title="Umyotube player" frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
            </div>
          </div>
        </ng-container>

        <ng-container *ngFor="let v of vimeoArray">
          <div class="wl-video" *ngIf="v.vimeoVideoLink | videoEmbed as src">
            <p class="wl-video-title"><i class="fa-brands fa-vimeo-v"></i> {{ v.vimeoVideoTitle }}</p>
            <div class="wl-embed">
              <iframe [src]="src" [title]="v.vimeoVideoTitle || 'Vimeo player'" frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
            </div>
          </div>
        </ng-container>
      </section>

      <div class="wl-ctrls">
        <button type="button" class="ctrl-item" *ngIf="forwardCard" data-bs-toggle="modal" data-bs-target="#shareCard">
          <i class="fa-solid fa-share"></i><h3>Forward</h3>
        </button>
        <a (click)="navigateToHome()" type="button" class="ctrl-item">
          <i class="fa-solid fa-right-to-bracket"></i><h3>Sign Up</h3>
        </a>
        <button type="button" class="ctrl-item" *ngIf="saveCard" (click)="downloadVCard()">
          <i class="fa-solid fa-download"></i><h3>Save My Card</h3>
        </button>
      </div>

      <footer class="wl-footer">
        <img class="wl-qr" *ngIf="qrCodeImage" [src]="qrCodeImage" alt="QR Code" />
        <p class="wl-strip">Browse <i></i> Click <i></i> Connect</p>
        <p class="wl-powered">This card is powered by <span>UMYO Cards</span></p>
        <form action="" class="referal-form" *ngIf="inviteCode">
          <label for="referal">Referral ID: </label>
          <input type="text" name="referal" id="referal" [value]="referal" disabled placeholder="XXXXX" />
        </form>
        <a [routerLink]="['/']" class="call-to-action">
          <span class="left">Click<br />Here</span>
          <span class="right">Design your card now!</span>
        </a>
      </footer>

    </div>
  </div>
</div>